export const MembershipStatus = Object.freeze({
  // The following enum values map to values from the POST Create Membership API response
  PENDING: 'pended',
  CREATED: 'approved',
  EDIT: 'edit'
});

export default MembershipStatus;
